import type { Role } from "@/constants/navigation";

export enum DispatcherPermissionValue {
  ChatList = "chat.list",
  SendMessage = "chat.send_message",
  ControlChat = "chat.control",
  TransferBetweenDispatchers = "chat.transfer_between_dispatchers",

  TripMonitorList = "trip_monitor.list",
  CheckCallsEdit = "check_calls.edit",
  CheckCallsList = "check_calls.list",
  BrokerUpdatesEdit = "broker_updates.edit",
  BrokerUpdatesList = "broker_updates.list",

  DispatchersList = "dispatchers.list",
  DispatchersLogs = "dispatchers.logs",
  DispatchersEdit = "dispatchers.edit",
  DispatchersArchive = "dispatchers.archive",

  UsersList = "users.list",
  UsersInfo = "users.info",
  UsersEdit = "users.edit",
  UsersArchive = "users.archive",

  OrdersList = "orders.list",
  OrdersInfo = "orders.info",
  OrdersEdit = "orders.edit",

  TripsEdit = "trips.edit",
  TripsInfo = "trips.info",
  TripsRouteActions = "trips.route_actions",

  CompaniesList = "companies.list",
  CompaniesEdit = "companies.edit",

  TrucksList = "trucks.list",
  TrucksInfo = "trucks.info",
  TrucksEdit = "trucks.edit",
  TrucksReserve = "trucks.reserve",
  TrucksArchive = "trucks.archive",
  TrucksChangeStatus = "trucks.change_status",
  TrucksSearch = "trucks.search",

  BillingReportGenerate = "billing_report.generate",
  BillingReportList = "billing_report.list",

  MapShowTrucks = "map.show_trucks",
}

export enum DispatcherPermissionName {
  ChatList = "Chat list",
  SendMessage = "Send message",
  ControlChat = "Chat control",
  TransferBetweenDispatchers = "Transfer_between_dispatchers",

  TripMonitorList = "Trip monitor list",
  CheckCallsEdit = "Check call add/edit",
  CheckCallsList = "Check calls list",
  BrokerUpdatesEdit = "Broker update add/edit",
  BrokerUpdatesList = "Broker updates list",

  DispatchersList = "Dispatchers list",
  DispatchersLogs = "Dispatchers logs",
  DispatchersEdit = "Dispatcher edit",
  DispatchersArchive = "Dispatcher archive",

  UsersList = "Users list",
  UsersInfo = "User info",
  UsersEdit = "User edit",
  UsersArchive = "User archive",

  OrdersList = "Orders list",
  OrdersInfo = "Order info",
  OrdersEdit = "Order add/edit",

  TripsEdit = "Trip edit",
  TripsInfo = "Trip info",
  TripsRouteActions = "Trip route_actions",

  CompaniesList = "companies.list",
  CompaniesEdit = "companies.edit",

  TrucksList = "Trucks list",
  TrucksInfo = "Truck info",
  TrucksEdit = "Trucks edit",
  TrucksReserve = "Trucks reserve",
  TrucksArchive = "Trucks archive",
  TrucksChangeStatus = "Trucks change_status",
  TrucksSearch = "Trucks search",

  BillingReportGenerate = "billing report generate",
  BillingReportList = "billing report list",

  MapShowTrucks = "Map::show trucks",
}

export interface DispatcherPermission {
  name: DispatcherPermissionName;
  value: DispatcherPermissionValue;
}

export interface DispatcherPermissionGroupItem {
  group: DispatcherPermissionGroup;
  permissions: DispatcherPermission[];
}

export enum DispatcherPermissionGroup {
  Chat = "Chat",
  TripMonitor = "Trip Monitor",
  Dispatchers = "Dispatchers",
  Users = "Users",
  Orders = "Orders",
  Trips = "Trips",
  Companies = "Companies",
  Trucks = "Trucks",
  Billing = "Billing",
  Map = "Map",
}

export interface CurrentDispatcher {
  id: number | null;
  name: string | null;
  firstName: string;
  lastName: string;
  roles: Role[];
  phone: string | null;
  phoneExt: string | null;
  timezone: string;
  company: DispatcherCompanyDto;
  isSuperAdmin: boolean;
  allExistingPermissions: DispatcherPermissionGroupItem[];
  permissions: DispatcherPermissionValue[];
}

export interface DispatcherCompanyDto {
  id: number;
  name: string;
  code: string;
}
